import React from 'react';
import { PrivacyPolicyContainer } from '../PrivacyPolicy/PrivacyStyles.styles';

const Prohibited = () => {
  return (
    <PrivacyPolicyContainer>
      <h3>Acceptable Use and Prohibited Activities</h3>

      <p>
        Users must use the Yoda Safety Services website, platform, content, and
        services lawfully, responsibly, and only for their intended purposes.
        You must not use our services in a way that interferes with the
        operation, security, integrity, or availability of the platform or the
        rights of Yoda Safety Services or other users.
      </p>

      <p>Users must not:</p>

      <ul>
        <li>
          Copy, reproduce, distribute, modify, publish, sell, resell, or
          otherwise use Yoda Safety Services content or materials except as
          permitted by these Terms & Conditions or an applicable agreement.
        </li>
        ```
        <li>
          Share account credentials, allow unauthorized individuals to access an
          account, or use another person&apos;s account without authorization.
        </li>
        <li>
          Access or attempt to access another user&apos;s, company&apos;s,
          employee&apos;s, or organization&apos;s information, records, forms,
          manuals, certificates, or other resources without authorization.
        </li>
        <li>
          Attempt to gain access to administrative functionality, restricted
          resources, accounts, systems, databases, or areas of the platform for
          which you have not been granted permission.
        </li>
        <li>
          Circumvent, bypass, disable, interfere with, or attempt to defeat
          account permissions, role-based access controls, authentication
          systems, security measures, or other platform restrictions.
        </li>
        <li>
          Share, reproduce, distribute, publish, or otherwise disclose quiz
          questions, assessment materials, answers, or other restricted training
          content to unauthorized individuals.
        </li>
        <li>
          Manipulate or attempt to manipulate course progress, quiz or
          assessment results, completion records, training records,
          certificates, or other information maintained through the platform.
        </li>
        <li>
          Alter, falsify, fraudulently reproduce, misuse, or misrepresent a
          certificate, training record, assessment result, form entry, or other
          record generated or maintained through the platform.
        </li>
        <li>
          Submit information, complete training, take quizzes or assessments, or
          create records while falsely representing yourself as another
          individual.
        </li>
        <li>
          Use digital safety forms, manuals, documents, company information, or
          other platform resources for purposes outside the access or
          permissions granted to you.
        </li>
        <li>
          Grant subcontractors, employees, managers, or other individuals access
          to resources beyond the permissions they are authorized to receive.
        </li>
        <li>
          Upload, submit, transmit, or introduce malicious code, viruses,
          harmful files, or other material intended to damage, disrupt,
          compromise, or interfere with the platform or its users.
        </li>
        <li>
          Probe, scan, test, or attempt to identify vulnerabilities in the
          platform or its infrastructure without prior written authorization
          from Yoda Safety Services.
        </li>
        <li>
          Use automated systems, scripts, bots, scraping tools, or similar
          methods to access, extract, copy, or interfere with platform content
          or data without authorization.
        </li>
        <li>
          Use the platform or services for fraudulent, unlawful, abusive, or
          otherwise unauthorized purposes.
        </li>
        <li>
          Use Yoda Safety Services content, platform functionality, or services
          in a manner that infringes the intellectual property, privacy,
          confidentiality, or other legal rights of another person or
          organization.
        </li>
        <li>
          Attempt to disrupt, overload, damage, degrade, or interfere with the
          operation or availability of the website, platform, or services.
        </li>
        ```
      </ul>

      <h4>Enforcement</h4>

      <p>
        If Yoda Safety Services reasonably believes that a user has violated
        these Terms & Conditions, misused the platform, created a security risk,
        or accessed information or resources without authorization, we may take
        reasonable action to protect the platform, our users, and our services.
      </p>

      <p>
        Depending on the circumstances, this may include restricting access to
        specific features, suspending or terminating account access, preserving
        relevant records, contacting the applicable company or account
        administrator, or taking other appropriate action. Where required,
        suspected unlawful activity may be reported to appropriate authorities.
      </p>
    </PrivacyPolicyContainer>
  );
};

export default Prohibited;
